import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";

const name = 'inspectionResult';

const initialState = {
    data: [],
    selection: [],
    pageNumber: 0,
    pageSize: 10,
    drafts: {},
    criteria: {},
    sort: null,
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setData(state, action) {
            state.data = json.toJSON(action.payload);
        },
        setSelection(state, action) {
            state.selection = action.payload;
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageSize(state, action) {
            state.pageSize = action.payload;
        },
        setDrafts(state, action) {
            state.drafts = json.toJSON(action.payload);
        },
        setCriteria(state, action) {
            state.criteria = action.payload;
        },
        setSort(state, action) {
            state.sort = action.payload;
        },
    }
})

export const { setData, setSelection, setPageNumber, setPageSize, setDrafts, setSort, setCriteria} = slice.actions;
export const { reducer } = slice;

export const selectData = state => json.fromJSON(state[name].data);
export const selectSelection = state => state[name].selection;
export const selectPageNumber = state => state[name].pageNumber;
export const selectPageSize = state => state[name].pageSize;
export const selectDrafts = state => json.fromJSON(state[name].drafts);
export const selectCriteria = state => state[name].criteria;
export const selectSort = state => state[name].sort;

export const selectDraft =  (key) => (state) => selectDrafts(state)[key];
export const setDraft = (key, draft) => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    drafts[key] = draft;
    dispatch(setDrafts(drafts));
}
export const removeDraft = key => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    delete drafts[key];
    dispatch(setDrafts(drafts));
}

const inspectionResultReducer = reducer;
export default inspectionResultReducer;